<div class="p-6 bg-white dark:bg-gray-900">
    <h2 class="text-xl font-semibold mb-4 dark:text-gray-100 flex items-center gap-2">
        <app-record-id-badge [value]="data?.doctor_crm?.doctor_crm_id"></app-record-id-badge>
        {{ (data.doctor_crm ? 'Editar CRM' : 'Adicionar CRM') | autoTranslate }}
    </h2>

    <form [formGroup]="form" class="space-y-4">
        <div>
            <mat-form-field class="w-full">
                <mat-label autoTranslate>CRM</mat-label>
                <input
                    type="text"
                    formControlName="professional_number"
                    matInput
                    [mask]="'00000-AA'"
                    [showMaskTyped]="true"
                    [dropSpecialCharacters]="false"
                    placeholder="12345-GO"
                    (blur)="onCrmBlur()"
                />
                <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="consultMedic()"
                    [disabled]="searchingCrm || form.get('professional_number')?.invalid"
                    [matTooltip]="'Consultar CRM no CFM' | autoTranslate"
                >
                    <mat-icon>{{ searchingCrm ? 'hourglass_empty' : 'search' }}</mat-icon>
                </button>
                <mat-hint autoTranslate>Formato: 12345-GO</mat-hint>
                <mat-error *ngIf="form.get('professional_number')?.hasError('required') && form.get('professional_number')?.touched" autoTranslate>
                    Campo Obrigatório
                </mat-error>
                <mat-error *ngIf="form.get('professional_number')?.hasError('pattern') && form.get('professional_number')?.touched" autoTranslate>
                    CRM deve estar no formato: NÚMERO-UF (ex: 12345-GO)
                </mat-error>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="w-full">
                <mat-label autoTranslate>Status</mat-label>
                <input 
                    type="text" 
                    formControlName="status" 
                    matInput 
                    readonly 
                    [placeholder]="data.doctor_crm ? '' : 'Aguardando consulta CFM...'"
                />
                <mat-hint autoTranslate>Preenchido automaticamente pela consulta CFM</mat-hint>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="w-full">
                <mat-label autoTranslate>Especialidades</mat-label>
                <textarea formControlName="specialties" matInput rows="3" readonly></textarea>
                <mat-hint autoTranslate>Preenchido automaticamente pela consulta CFM</mat-hint>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="w-full">
                <mat-label autoTranslate>Data de Emissão</mat-label>
                                <input [ngxMatDatetimePicker]="datetimePickerIssue" formControlName="license_issue_date" matInput />
                <ngx-mat-datepicker-toggle matSuffix [for]="datetimePickerIssue"></ngx-mat-datepicker-toggle>
<ngx-mat-datetime-picker #datetimePickerIssue [showSpinners]="true" [showSeconds]="false" [stepHour]="1" [stepMinute]="1" [touchUi]="false" [enableMeridian]="false" color="primary"></ngx-mat-datetime-picker>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="w-full">
                <mat-label autoTranslate>Data de Expiração</mat-label>
                                <input [ngxMatDatetimePicker]="datetimePickerExpiry" formControlName="license_expiry_date" matInput />
                <ngx-mat-datepicker-toggle matSuffix [for]="datetimePickerExpiry"></ngx-mat-datepicker-toggle>
<ngx-mat-datetime-picker #datetimePickerExpiry [showSpinners]="true" [showSeconds]="false" [stepHour]="1" [stepMinute]="1" [touchUi]="false" [enableMeridian]="false" color="primary"></ngx-mat-datetime-picker>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="w-full">
                <mat-label autoTranslate>Data de Emissão (Emissão)</mat-label>
                                <input [ngxMatDatetimePicker]="datetimePickerEmission" formControlName="license_issue_date_emission" matInput />
                <ngx-mat-datepicker-toggle matSuffix [for]="datetimePickerEmission"></ngx-mat-datepicker-toggle>
<ngx-mat-datetime-picker #datetimePickerEmission [showSpinners]="true" [showSeconds]="false" [stepHour]="1" [stepMinute]="1" [touchUi]="false" [enableMeridian]="false" color="primary"></ngx-mat-datetime-picker>
            </mat-form-field>
        </div>
    </form>

    <div class="flex justify-between items-center gap-2 mt-6">
        <div>
            <button
                *ngIf="data.doctor_crm"
                mat-stroked-button
                color="warn"
                (click)="remove()"
                [disabled]="loading || removing"
                autoTranslate
            >
                Remover
            </button>
        </div>
        <div class="flex gap-2">
            <button mat-button (click)="cancel()" [disabled]="loading || removing" autoTranslate>Cancelar</button>
            <button mat-raised-button color="primary" (click)="save()" [disabled]="loading || removing || form.invalid || searchingCrm" autoTranslate>
                {{ (data.doctor_crm ? 'Atualizar' : 'Adicionar') | autoTranslate }}
            </button>
        </div>
    </div>
</div>
